export const validateMaxUnitPrice = (items, selectedSkus, selectedProducts, isSku, setMaxUnitPrice, setMaxProductPrice) => {
  let isAboveMaxProdPrice = false;
  const itemsToCheck = [...items];
  const sourceList = isSku ? [...selectedSkus] : [...selectedProducts];

  itemsToCheck.forEach((item) => {
    const sourceItem = sourceList.find(
      (p) => (isSku ? p.product_id : p.id) === item.product_id
    );
    if (sourceItem && sourceItem.price !== undefined) {
      const calculatedPrice = sourceItem.price * 1.2;

      if (item.item_price > calculatedPrice) {
        setMaxUnitPrice(item.item_price);
        setMaxProductPrice(calculatedPrice);
        isAboveMaxProdPrice = true;
      }
    }
  });
  return isAboveMaxProdPrice;
};

export const validateMinUnitPrice = (isSku, items, selectedSkus, selectedProducts, setMinUnitPrice, setMinProductPrice) => {
  let isBelowMinProdPrice = false;
  const itemsToCheck = [...items];
  const sourceList = isSku ? [...selectedSkus] : [...selectedProducts];

  itemsToCheck.forEach((item) => {
    const sourceItem = sourceList.find(
      (p) => (isSku ? p.product_id : p.id) === item.product_id
    );
    if (sourceItem && sourceItem.price !== undefined) {
      const calculatedPrice = sourceItem.price * 0.9;
      if (item.item_price < calculatedPrice) {
        setMinUnitPrice(item.item_price);
        setMinProductPrice(calculatedPrice);
        isBelowMinProdPrice = true;
      }
    }
  });
  return isBelowMinProdPrice;
};
